import { useNavigate } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import { FiExternalLink, FiGithub } from 'react-icons/fi';
import "./ButtonRepoAndEnterCardContent.css";

const ButtonRepoAndEnterCardContent = ({ urlPage, urlGit }) => {
  const navigate = useNavigate();
  const sizeIcon = "1.3em";

  return (
    <Grid item container xs={12} justifyContent="center">
      <div
        className="btn-card-content"
        onClick={() => {
          if (/https/.test(urlPage)) {
            window.open(urlPage, '_blank')
            return
          }
          navigate(`/projects/${urlPage}`)
        }}>
        Abrir
        <div className="icon-card-content external-link">
          <FiExternalLink size={sizeIcon} />
        </div>
      </div>
      <a target="_blank" rel="noreferrer noopener" href={urlGit}>
        <div className="btn-card-content" >
          Repo
          <div className="icon-card-content">
            <FiGithub size={sizeIcon} />
          </div>
        </div>
      </a>
    </Grid>
  );
}

export default ButtonRepoAndEnterCardContent;

//los botones son div xq ProjectFrame contiene todo sus childrens en un button, y si hay botones dentro de botones aparecen warnings 🤷‍♂️
